// extracted by mini-css-extract-plugin
export default {"root":"_1QWZA","toggle":"_25PaX","active":"_1wEYU","dot":"_3K4-g"};